/**
 * GeChiUI dependencies
 */
import { __ } from '@gechiui/i18n';
import { MenuItem } from '@gechiui/components';

export default function BlockConvertButton( { shouldRender, onClick, small } ) {
	if ( ! shouldRender ) {
		return null;
	}

	const label = __( 'Convert to Blocks' );
	return <MenuItem onClick={ onClick }>{ ! small && label }</MenuItem>;
}
